import React from 'react';

const Description = ({ content, letters }) => {
    // 1️⃣ HTML tags remove karne ke liye
    const plainText = content.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ');

    // 2️⃣ text limit set karo (e.g., 50 characters tak)
    const limit = letters || 500;
    const shortText =
        plainText.length > limit
            ? plainText.substring(0, limit) + '...'
            : plainText;

    return (
        <p className='m-0' style={{ fontSize: "13px" }}>{shortText}</p>
    );
};

export default Description;
